<div [formGroup]="form">
  <div class="form-group">
    <app-date-picker
      label="Date of Subdivision / Consolidation"
      formControlName="subdivisionDate"
      [smallWidth]="true"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [customErrors]="customDatepickerErrors"
    />
  </div>

  <div class="subdivision share-numbers-grid">
    <div class="form-group share-types">
      <app-share-security-holdings-dropdown
        formControlName="securityHoldingClass"
        [options]="securityRegistryRecordsHoldings"
        [hidePrice]="true"
      />
    </div>

    <div class="form-group">
      <app-input-number
        label="New Number of Shares"
        formControlName="newNumberShares"
        [customErrors]="newNumberOfSharesCustomErrors"
        [min]="newNumberOfSharesMinValue"
      />
    </div>
  </div>

  <div>
    <app-disclaimer icon="ic-alert-triangle-20" color="orange">
      <div>If the number of shares has increased, this is considered a <b class="font-weight-500">Subdivision</b>.</div>
      <div>If the number of shares has decreased, this is considered a <b class="font-weight-500">Consolidation</b>.</div>
    </app-disclaimer>
  </div>
</div>
